export var isTaskPersonal = function (task, playerAccount) {
    return task.to === playerAccount.id;
};
